import * as React from 'react';

import { useSpeciesContext } from './ISpeciesContext';
import { SpeciesEdit } from './SpeciesEdit';
import { SpeciesCreate } from './SpeciesCreate';
import { SpeciesView } from './SpeciesView';
import { SpeciesList } from './SpeciesList';

const SpeciesPane = () => {
  const ctx = useSpeciesContext();
  
  return (
    <>
      {/* List is always present, but it may be hidden. */}
      <div style={{ flexDirection: 'column', width: '100%', height: '100%', display: ctx.mode == 'list' ? 'flex' : 'none' }}>
        <SpeciesList/>
      </div>
      {ctx.mode == 'view' && <SpeciesView/>}
      {ctx.mode == 'edit' && <SpeciesEdit/>}
      {ctx.mode == 'create' && <SpeciesCreate/>}
    </>
  );
}

export { SpeciesPane }
